import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import PortalLogin_View from "../../Views/PortalLogin_View";

const API_URL = process.env.REACT_APP_CLIENT_API_URL;

export default function PortalLogin_Controller() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  // Se già loggato, redirect alla dashboard
  useEffect(() => {
    const token = sessionStorage.getItem("portal_token");
    if (token) navigate("/dashboard", { replace: true });
  }, [navigate]);

  const handleLogin = async (e) => {
    e?.preventDefault();
    setError("");

    if (!email.trim()) { setError("Inserisci la tua email"); return; }
    if (!password) { setError("Inserisci la tua password"); return; }

    setLoading(true);
    try {
      const res = await fetch(`${API_URL}/api/client/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email: email.trim().toLowerCase(), password }),
      });
      const data = await res.json();

      if (res.ok) {
        sessionStorage.setItem("portal_token", data.token);
        sessionStorage.setItem("portal_user", JSON.stringify(data.client));
        navigate("/dashboard", { replace: true });
      } else {
        setError(data.error || "Errore di accesso");
      }
    } catch {
      setError("Impossibile connettersi al server. Riprova più tardi.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <PortalLogin_View
      email={email}
      password={password}
      loading={loading}
      error={error}
      onEmailChange={(e) => { setEmail(e.target.value); setError(""); }}
      onPasswordChange={(e) => { setPassword(e.target.value); setError(""); }}
      onSubmit={handleLogin}
    />
  );
}
